export class Login {

    public UserName: string;
    public Password: string;
    public FirstName: string;
    public Email: string;
    public RememberMe: string;
    public CitizenID: string;
    public IsValid: boolean;
    public RegStatus: string;
    public Token: string;
    public pawnMenu: boolean;

}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/login.model.ts